'use client';
import { isPC, uniframeReady } from '@spot-fe/utils';
import { useEffect, useState } from 'react';

import { IUserInfo } from '../provider';

interface Props {
  locale?: string;
  userInfo?: IUserInfo;
  uniframeHasReady?: boolean;
}

const DELAY_TIME = 10000;

export function AdaBot({ locale = 'en', userInfo, uniframeHasReady }: Props) {
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    let timer = 0;
    if (isPC() && uniframeHasReady) {
      timer = window.setTimeout(() => {
        uniframeReady().then(() => {
          (window as any)?.BybitUniFrame?.ready(
            ({ adaBot }: { adaBot: any }) => {
              adaBot.init();
              setInitialized(true);
            }
          );
        });
      }, DELAY_TIME);
    }

    return () => {
      window.clearTimeout(timer);
    };
  }, [uniframeHasReady]);

  useEffect(() => {
    if (initialized) {
      uniframeReady().then(() => {
        (window as any)?.BybitUniFrame?.ready(({ adaBot }: { adaBot: any }) => {
          const { LANG } = adaBot.properties;
          adaBot.setProperty(LANG, locale);
        });
      });
    }
  }, [initialized, locale]);

  useEffect(() => {
    if (initialized && userInfo) {
      uniframeReady().then(() => {
        (window as any)?.BybitUniFrame?.ready(({ adaBot }: { adaBot: any }) => {
          const { USER_INFO } = adaBot.properties;
          adaBot.setProperty(USER_INFO, userInfo);
        });
      });
    }
  }, [initialized, userInfo]);

  return null;
}

export const ADASupportScript = AdaBot;
